import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { InstagramLogo, TiktokLogo, YoutubeLogo, LinkedinLogo, WhatsappLogo, ArrowUpRight, MapPin } from "@phosphor-icons/react";
import SeoulClock from "./SeoulClock";

const HQ = {
  line1: "Level 41, Gangnam Finance Center, 152 Teheran-ro, Gangnam-gu",
  line2: "Seoul 06236 · South Korea",
  mapsHref:
    "https://www.google.com/maps/search/?api=1&query=Gangnam+Finance+Center+152+Teheran-ro+Gangnam-gu+Seoul",
};

export default function Footer() {
  const [social, setSocial] = useState({});
  useEffect(() => { api.get("/social").then((r) => setSocial(r.data)).catch(() => {}); }, []);

  const items = [
    { key: "instagram", icon: InstagramLogo, label: "Instagram" },
    { key: "tiktok", icon: TiktokLogo, label: "TikTok" },
    { key: "youtube", icon: YoutubeLogo, label: "YouTube" },
    { key: "linkedin", icon: LinkedinLogo, label: "LinkedIn" },
    { key: "whatsapp", icon: WhatsappLogo, label: "WhatsApp" },
  ];

  return (
    <footer data-testid="site-footer" className="bg-[#0F172A] text-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 pt-16 md:pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <h3 className="font-display text-4xl md:text-5xl font-bold tracking-tight leading-[1.05]">
              Korean lifestyle, <br />
              <span className="font-serif italic font-normal text-white/70">always in motion.</span>
            </h3>
            <p className="mt-5 text-white/60 leading-relaxed max-w-md text-sm">
              Born in South Korea. Built for the global feed.
            </p>
            <div className="mt-8"><SeoulClock className="text-white" /></div>

            {/* HQ Address — Gangnam Finance Center */}
            <div className="mt-10 max-w-xl" data-testid="footer-address">
              <div className="label-uppercase text-white/40 mb-3">Visit · Studio</div>
              <div className="flex items-start gap-3">
                <span className="mt-1 w-9 h-9 shrink-0 rounded-full border border-white/15 flex items-center justify-center text-[#FF6B9E]">
                  <MapPin size={16} weight="duotone" />
                </span>
                <address className="not-italic text-sm leading-[1.7] text-white/80 whitespace-nowrap">
                  <div className="text-white/85">{HQ.line1}</div>
                  <div className="text-white/60">{HQ.line2}</div>
                  <a
                    href={HQ.mapsHref}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="footer-address-directions"
                    className="mt-3 inline-flex items-center gap-1.5 text-[11px] tracking-[0.22em] uppercase text-white/80 hover:text-[#FF6B9E] transition-colors"
                  >
                    Get Directions <ArrowUpRight size={12} weight="bold" />
                  </a>
                </address>
              </div>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="label-uppercase text-white/40 mb-4">Index</div>
            <ul className="space-y-2 text-sm text-white/80">
              <li><a href="#categories" className="hover:text-[#FF6B9E] transition-colors">Categories</a></li>
              <li><a href="#about" className="hover:text-[#FF6B9E] transition-colors">About</a></li>
              <li><a href="#social" className="hover:text-[#FF6B9E] transition-colors">Social World</a></li>
              <li><a href="#contact" className="hover:text-[#FF6B9E] transition-colors">Partner</a></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="label-uppercase text-white/40 mb-4">Follow</div>
            <div className="flex gap-2.5 flex-wrap">
              {items.map(({ key, icon: Icon, label }) => (
                <a
                  key={key}
                  href={social[key] || "#"}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`social-${key}`}
                  className="w-10 h-10 rounded-full border border-white/15 hover:bg-[#FF6B9E] hover:border-[#FF6B9E] transition-all duration-300 flex items-center justify-center"
                  aria-label={label}
                >
                  <Icon size={16} weight="regular" />
                </a>
              ))}
            </div>
            <a href="#contact" className="mt-6 inline-flex items-center gap-2 text-xs tracking-[0.22em] uppercase text-white/80 hover:text-white">
              Partner with us <ArrowUpRight size={14} weight="bold" />
            </a>
          </div>
        </div>
        <div className="border-t border-white/10 mt-14 pt-6 flex flex-wrap items-center justify-between gap-3 text-[11px] tracking-[0.22em] uppercase text-white/40">
          <span>© {new Date().getFullYear()} Hangang Global</span>
          <span>Made in South Korea · Worn worldwide</span>
        </div>
      </div>
    </footer>
  );
}
